import { render } from "./loadingScreen.vue?vue&type=template&id=16daabc2&scoped=true"
import script from "./loadingScreen.vue?vue&type=script&lang=js"
export * from "./loadingScreen.vue?vue&type=script&lang=js"

import "./loadingScreen.vue?vue&type=style&index=0&id=16daabc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16daabc2"]])

export default __exports__